import { z } from 'zod';

// ----------- Form Keys -----------
// These are pure TypeScript types with NO Zod dependency
// Safe to import anywhere without pulling in Zod
const FORM_KEYS = {
    LEAD_INQUIRY: 'LEAD_INQUIRY',
    PREQUALIFICATION: 'PREQUALIFICATION',
};
const formKeyValues = [FORM_KEYS.LEAD_INQUIRY, FORM_KEYS.PREQUALIFICATION];
const FormKeySchema = z.enum(formKeyValues);

export { FORM_KEYS, FormKeySchema, formKeyValues };
//# sourceMappingURL=types.js.map
